import configure from '../configure'
import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default class Team {

  fetch (championshipId) {
    return Vue.http.get(configure.api_url + 'teams?championship_id=' + championshipId).then(response => {
      return response
    })
  }

  get (id) {
    return Vue.http.get(configure.api_url + 'teams/' + id).then(response => {
      return response
    })
  }

  put (team) {
    return Vue.http.put(
      configure.api_url + 'teams/' + team.id,
      team
    ).then(response => {
      return response
    })
  }

  post (team) {
    return Vue.http.post(
      configure.api_url + 'teams',
      team
    ).then(response => {
      return response
    })
  }

  delete (id) {
    return Vue.http.delete(
      configure.api_url + 'teams/' + id
    ).then(response => {
      return response
    })
  }

  attach (id, award) {
    return Vue.http.post(
      configure.api_url + 'teams/' + id + 'award',
      award
    ).then(response => {
      return response
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/api/team.js
 **/